import closeIcon from '/images/close-icon.svg'
import { dismissModal } from '@el5/native-api'
import clsx from 'clsx'
import type React from 'react'

import classes from './styles.module.css'

interface Props {
  title?: string
  wrapClassName?: string
}

export const Layout = ({
  title,
  children,
  wrapClassName,
}: React.PropsWithChildren<Props>) => {
  return (
    <div className={clsx(classes.layout, wrapClassName)}>
      {title && (
        <header className={classes.header}>
          <button
            className={classes.buttonClose}
            onClick={() => dismissModal()}
          >
            <img src={closeIcon} alt="" />
          </button>
          <div>{title}</div>
        </header>
      )}

      <main className={classes.main}>{children}</main>
    </div>
  )
}
